import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { EndorsementComponent } from './component/endorsement.component';

@NgModule({
  declarations: [EndorsementComponent],
  imports: [
    CommonModule,
    FormPlycaModule
  ],
  exports: [EndorsementComponent]
})
export class EndorsementModule {

}